export default "__VITE_ASSET__DO4cn3CI__"